import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { Navigate, Outlet } from "react-router-dom";
import { Loading } from "@/components/atoms";

/**
 * Route guard that requires Kinde authentication
 * Redirects to /login if not authenticated
 * Shows loading state while checking authentication
 *
 * Note: Driver detection and redirection is handled by AuthCallback.
 * This guard only ensures the user is authenticated via Kinde.
 */
export const RequireAuth = () => {
  const { isAuthenticated, isLoading: isKindeLoading } = useKindeAuth();

  // Show loading while Kinde is checking auth
  if (isKindeLoading) return <Loading />;

  // Not authenticated - redirect to login
  if (!isAuthenticated) return <Navigate to="/login" replace />;

  // Authenticated - allow through
  return <Outlet />;
};
